import { render, staticRenderFns } from "./TransbankResult.vue?vue&type=template&id=61fb7470&"
import script from "./TransbankResult.vue?vue&type=script&lang=js&"
export * from "./TransbankResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports